import { createAction } from "@reduxjs/toolkit";

// No-op action that forces redux-undo to record an entry by returning a new object.
export const pushTabSnapshotForUndo = createAction("tabGroup/pushSnapshotForUndo");
